import React, { ReactElement } from 'react'
import { useQueueSnapshot } from '../../Hooks/useQueueSnapshot'
import * as Styled from './Queue.styled'

const MAX_CHIPS = 8

const QueueBoard = (): ReactElement => {
  const { snapshot, stale } = useQueueSnapshot()

  if (!snapshot) {
    if (!stale) {
      return (
        <Styled.Page>
          <Styled.Sub>Loading…</Styled.Sub>
        </Styled.Page>
      )
    }

    return (
      <Styled.Page>
        <Styled.Headline>Can&apos;t reach the queue</Styled.Headline>
        <Styled.Sub>Still trying — this page keeps retrying automatically.</Styled.Sub>
        <Styled.Foot>Reconnecting…</Styled.Foot>
      </Styled.Page>
    )
  }

  const { nowServing, waiting } = snapshot
  const extra = waiting.length - MAX_CHIPS

  return (
    <Styled.Page>
      {waiting.length === 0 && nowServing === null ? (
        <>
          <Styled.Headline>No queue</Styled.Headline>
          <Styled.Sub>Order now — no wait</Styled.Sub>
        </>
      ) : (
        <>
          <Styled.Label>Now serving</Styled.Label>
          <Styled.BigNumber>{nowServing === null ? '—' : `R${nowServing}`}</Styled.BigNumber>
          <Styled.Label>
            {waiting.length === 0
              ? 'No orders waiting'
              : `${waiting.length} ${waiting.length === 1 ? 'order' : 'orders'} waiting`}
          </Styled.Label>
          <Styled.Chips>
            {waiting.slice(0, MAX_CHIPS).map((n) => (
              <Styled.Chip key={n}>R{n}</Styled.Chip>
            ))}
            {extra > 0 && <Styled.Chip>+{extra} more</Styled.Chip>}
          </Styled.Chips>
        </>
      )}
      <Styled.Note>Online pickup orders (P) — we&apos;ll SMS you when ready</Styled.Note>
      <Styled.Foot>{stale ? 'Reconnecting…' : 'Updates every 10 seconds'}</Styled.Foot>
    </Styled.Page>
  )
}

export default QueueBoard
